import React, { useState, useEffect, useContext, useMemo } from 'react';
import { Card } from 'reactstrap';
import { ReactComponent as BackArrow } from "assets/img/svg/BackArrow.svg";
import { useHistory } from 'react-router-dom';
import APopover from 'views/pages/manage/common/a-popover';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import { ReactComponent as DownloadIcon } from "../../../../../../../assets/img/svg/downloadBlack.svg";
import { ReactComponent as UploadIcon } from "../../../../../../../assets/img/svg/fi_upload.svg";

import FilterForm from './FilterForm';
import DocUploadModal from 'views/pages/manage/unAssigned/studentCharges/studentChargesDetails/paymentMode/DocUploadModal';
import BulkListing from './BulkListing';
import AAutoComplete from 'views/pages/manage/common/form-fields-mui/AAutoComplete';
import { serviceNameMapping } from "./constant"
import ConfirmationDialog from './ConfirmationDialog';
import { fetchAllPostPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import DownloadFiles from './DownloadListingDialog';
import { endpoint, pages } from '../../../../../manage/common/constant';
import { getAllActivePaymentMode, searchHandlerlisting } from './utils';
import { failureToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import ALoader from 'views/pages/manage/common/a-loader';
import { PermissionContext } from 'appContext';
import { RolePermissions } from 'appContext';
import { PermisionDenied } from 'views/pages/manage/common/commonComponents';
import { useGetUserRoledId } from 'views/pages/manage/unAssigned/examCharges/context/customHooks';
const BulkCollection = () => {
  const [loader, setLoader] = useState(false)
  const history = useHistory()
  const [filterCount, setFilterCount] = useState()
  const [dropdowns, setDropdowns] = useState({})
  const [globalFilter, setGlobalFilter] = useState({})
  const [isOpen, setOpen] = useState(false)
  const [successOpen, setSuccessOpen] = useState(false)
  const [rows, setRows] = useState([]);
  const [rowCount, setRowCount] = useState()
  const [paymentMode, setPaymentMode] = useState()
  const [fileData, setfileData] = useState();
  const [processTypeIdList, setProcessTypeIdList] = useState([])
 const roleId = useGetUserRoledId();
  const userPermissions =
    RolePermissions(
      useContext(PermissionContext),
      pages["paymentCollectionBulk"]["id"]
    ) || [];
  useEffect(() => {
    searchHandler();
  }, [])
  useEffect(()=>{
    roleId&&getAllDropdown(roleId)
  },[roleId])
  const getAllDropdown = async (roleId) => {
    setLoader(true)
    const {accessibleList, payModeProcessIdMapping} = await getAllActivePaymentMode(roleId)
   const currentAccessiblePaymodeList=accessibleList.map(item => ({ label: item?.label, value: item?.label }))
    setDropdowns(
      {
        paymode: currentAccessiblePaymodeList
      }
    )
    setProcessTypeIdList(payModeProcessIdMapping)
    setLoader(false)
  }
  const searchHandler = async (req = {}, page = 0) => {
    try {
      setLoader(true)
      const res = await searchHandlerlisting(req, page)
      setRows((res?.bulkCollectionFileDetailsList ?? []).map((item, index) => ({ seqNo: index + 1, ...item })));
      setRowCount(res?.totalRecords)
    }

    catch (err) {

      console.log(err)
    }
    finally {
      setLoader(false)
    }
  }
  const uploadSaveHandler = async (file,setFile,setFileData) => {
    const reqObj = {
      processId: file?.processId,
      status: "ACTIVE",
      extId: file?.processId,
      documentType: "csv",
      signedUrl: "",
      isProcess: true,
      serviceName: serviceNameMapping?.[paymentMode?.value],
      processTagTypeId: processTypeIdList?.[paymentMode?.value]
    }
    setfileData({
      bulkUploadS3Key: file?.s3Key,
      fileName: file?.fileName,
    });

    setLoader(true)
    try {
      const resp = await fetchAllPostPromisedData(
        endpoint.fetchS3Url.commonUploadDms,
        reqObj,
        "post"
      );
      if (resp?.code === 200) {
        setOpen(false);
        setSuccessOpen(true)
        setFile(null)
        setFileData(null)
        setTimeout(() => {
          setSuccessOpen(false)
          searchHandler({})
          // window.location.reload();
          setPaymentMode('')
          setfileData({
            bulkUploadS3Key: "",
            fileName: "",
          });

        }, 1000);
      } else failureToast("Something went wrong please try after sometime.");
    }
    catch (err) {
      console.log(err)
    }
    finally {
      setLoader(false)
    }
  }
  // const dropdowns?.paymode= useMemo(()=>{
  //   const l=bulkPayModeUploadDropdown?.map(item=>item?.value)
  //   console.log('accessibePaymodeTemList',l)
  //   return dropdowns?.paymode?.filter(item=>{
  //     console.log('item',item)
  //     if(l.includes(item?.value)){
  //       console.log('item',item)
  //       return item
  //     }
  //     })
  // },[dropdowns?.paymode])
  return (userPermissions ? <>
    <Card className="m-3 p-2">
      <div className='d-flex justify-content-between'>
        <div>
          <BackArrow className='mr-2 cursor' onClick={() => history.goBack()} />
          <h3 className='d-inline'>Bulk collection</h3>

        </div>
        <div>
          <APopover
            buttonComponent={(openPopover, styles) => (
              <AButton
                className="tiny-semi-bold color-dark"
                onClick={openPopover}
                size="xs"
                updatedStyle={{
                  minWidth: "61px",
                  ...(filterCount > 0
                    ? {
                      border: "1px solid #00B0F5",
                      color: "#00B0F5",
                    }
                    : styles),
                }}
              >
                Filters {filterCount > 0 ? `(${filterCount})` : ""}
              </AButton>
            )}
            menuComponent={(closePopup) =>
              <FilterForm
                closeForm={closePopup}
                dropdowns={dropdowns}
                accessibePaymodeTemList={dropdowns?.paymode}
                globalFilter={globalFilter}
                setGlobalFilter={setGlobalFilter}
                searchHandler={searchHandler}
                filterCount={filterCount}
                setFilterCount={setFilterCount}

              //filterCount={getFilterCount()}
              />
            }
          />
          <APopover
            buttonComponent={(openPopover, styles) => (
              <AButton
                className="tiny-semi-bold color-dark"
                onClick={openPopover}
                size="xs"
                updatedStyle={{
                  styles
                }}
              >
                <span className='d-flex justify-content-center align-items-center' style={{ gap: '10px' }}> <DownloadIcon /> Download collection template </span>
              </AButton>
            )}
            menuComponent={(closePopup) =>
              <DownloadFiles accessibePaymodeTemList={dropdowns?.paymode} />
            }
          />


          
          {userPermissions?.includes("B") && <AButton
            className="tiny-semi-bold color-dark"
            onClick={() => { setOpen(true) }}
            size="xs"
            updatedStyle={{
              minWidth: "61px",
            }}
            variant="primary_filled"
          >
            <span className='d-flex justify-content-center align-items-center' style={{ gap: '10px' }}> <UploadIcon /> Upload collection file </span>
          </AButton>}
        </div>


      </div>
      {loader && <ALoader position='fixed' />}
      <BulkListing rowData={rows} rowCount={rowCount} filterForm ={globalFilter}  searchHandler={searchHandler} />
    </Card>
    <ConfirmationDialog isOpen={successOpen} />
    <DocUploadModal
      open={isOpen}
      setOpen={setOpen}
      saveHandler={(s3Key, fileName, fileData,setFile,setFileData) => {
        uploadSaveHandler(fileData,setFile,setFileData)
      }}
      acceptedFileTypes={[".csv", ".xls"]}
      maxUploadFileSize={5}
      serviceName={serviceNameMapping?.[paymentMode?.value]}
      uniqueKeyParameter={"paymentCollectionImage"}
      uploadedFileS3Key={fileData?.bulkUploadS3Key}
      uploadedFileName={fileData?.fileName}
      modalTitle={"Upload collection file"}
      propStyle={{ overflow: 'auto', maxWidth: '325px' }}
      paymentMode={paymentMode}
      isBulkCollection={true}
      customComponent={<AAutoComplete
        label="Please select payment mode *"
        placeholder="Select to add"
        className='mb-1'
        items={dropdowns?.paymode}
        currentValue={paymentMode}
        isMulti={false}
        handleChange={(value) => {
          setPaymentMode(value)
        }}
        inputKey=""
      />}

    />

  </> : <PermisionDenied />
  )
}
export default BulkCollection